import { useState } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }
    setStatus('submitting');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9qspjee3oq4jqumtq80', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注。');
        setEmail('');
      } else {
        let parsed;
        try { parsed = JSON.parse(responseText); } catch { parsed = null; }
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后重试。';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="bg-background-900 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-500/20 mx-auto mb-6">
            <i className="ri-mail-send-line text-2xl text-primary-400"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
            获取h漫最新资讯
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-8 max-w-md mx-auto">
            订阅我们的资讯推送，第一时间获取h漫新品推荐、热门作品点评与行业动态。
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hidden-absolute"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-lg bg-background-800 border border-background-700 text-sm text-white placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white text-sm font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer"
            >
              {status === 'submitting' ? '提交中...' : '立即订阅'}
            </button>
          </form>

          {message && (
            <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
              {message}
            </p>
          )}

          <p className="mt-4 text-xs text-background-500">
            我们尊重你的隐私，不会发送垃圾邮件，可随时取消订阅。
          </p>
        </div>
      </div>
    </section>
  );
}